export default __webpack_public_path__ + "static/media/tick.6cb08fd1.svg";